import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Area } from 'src/app/shared/models/area';
import { ConstantsService } from '../constant/constants.service';
import { GenericCrudService } from '../generic-crud.service';

@Injectable({
	providedIn: 'root'
})
export class AreaService {
	constructor(
		private appConstants: ConstantsService,
		private genericCrudService: GenericCrudService
	) {}

	getAllAreasForUserCenter(): Observable<Area[]> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.areaUrl}s`,
			'getAllAreasForUserCenter'
		);
	}

	getAreaById(areaId: number): Observable<Area> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.areaUrl}/${areaId}`,
			`getAreaById(${areaId})`
		);
	}

	postArea(area: Area): Observable<Area> {
		return this.genericCrudService.genericPostDataToAPI(
			`${this.appConstants.areaUrl}`,
			`postArea`,
			area
		);
	}

	updateArea(area: Area): Observable<Area> {
		return this.genericCrudService.genericPutDataToAPI(
			`${this.appConstants.areaUrl}/${area.id}`,
			`updateArea`,
			area
		);
	}

	deleteArea(areaId: number): Observable<HttpResponse<void>> {
		return this.genericCrudService.genericDeleteAPIDataByID(
			`${this.appConstants.areaUrl}/${areaId}`,
			`deleteArea`
		);
	}
}
